"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let RentalServiceCostAllocator = class RentalServiceCostAllocator extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    service;
    onService(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("service");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.oid ?
            this.$fn.fetch('read_rental_service_cost_allocator', { parameters: { id: this.oid }, asResource: true }) :
            this.$fn.schemaDefaults('CreateRentalServiceCostAllocator', {
                rental_id: this.service.rental.id,
                rental_service_id: this.service.id,
            });
    }
    labelAlign;
    editor;
    async $$load_editor() {
        return this.item.editor();
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    createTitle;
    resourceTitle;
    ux;
    b_7315092382398562_modalBindings;
    b_7789867021953041_dataSource;
    dataMembers = ['item', 'labelAlign', 'editor', 'formName', 'formId', 'createTitle', 'resourceTitle', 'ux', 'b_7315092382398562_modalBindings', 'b_7789867021953041_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                labelAlign: "right",
                editor: null,
                formName: "rentalServiceCostAllocator",
                formId: null,
                createTitle: this.$fn.pgettext("RentalServiceCostAllocator", "New cost allocator"),
                resourceTitle: this.$fn.pgettext("RentalServiceCostAllocator/header", "Cost allocator"),
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
                b_7789867021953041_dataSource: {
                    name: "suggest_meter",
                    parameters: {
                        types_only: "cost_allocator",
                    },
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [!this.oid && this.createTitle,
                    this.item && this.item.meter && this.item.meter.serial_number,
                ],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9528_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeComponent_9534_getActionArgs($event) {
        return {
            result: {
                ok: true,
            },
        };
    }
    async act_1040167445267876_rest_9532_getActionArgs($event) {
        return {
            method: "save",
            container: this.editor.cost_allocators,
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9528 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9528_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9527 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9528,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9527],
        });
        const act_2248226175642056_closeComponent_9530 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9529 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9530,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9529],
        });
        const act_1040167445267876_closeComponent_9534 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1040167445267876_closeComponent_9534_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_saved_9533 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeComponent_9534,
            event: "saved",
            displayName: "closeComponent",
        });
        const act_1040167445267876_rest_9532 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_9532_getActionArgs,
            displayName: "create",
            events: [evh_1040167445267876_saved_9533],
        });
        const evh_1040167445267876_submit_9531 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_9532,
            event: "submit",
            displayName: "create",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9531],
        });
        const act_1419464017721962_closeComponent_9536 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_9535 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_9536,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_9535],
        });
        return {
            act_7315092382398562_closeModal_9528,
            evh_7315092382398562_close_9527,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9530,
            evh_2248226175642056_close_9529,
            evh_2248226175642056_close,
            act_1040167445267876_closeComponent_9534,
            evh_1040167445267876_saved_9533,
            act_1040167445267876_rest_9532,
            evh_1040167445267876_submit_9531,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_9536,
            evh_1419464017721962_clickPreventStop_9535,
            evh_1419464017721962_clickPreventStop,
            create: act_1040167445267876_rest_9532,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], RentalServiceCostAllocator.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalServiceCostAllocator.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], RentalServiceCostAllocator.prototype, "service", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('service'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalServiceCostAllocator.prototype, "onService", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], RentalServiceCostAllocator.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalServiceCostAllocator.prototype, "onSize", null);
RentalServiceCostAllocator = __decorate([
    (0, vue_property_decorator_1.Component)()
], RentalServiceCostAllocator);
exports.default = RentalServiceCostAllocator;
vue_property_decorator_1.Vue.component("RentalServiceCostAllocator", RentalServiceCostAllocator);
